import { NgForOf, NgIf } from '@angular/common';
import { Component, inject, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { PortalFieldTypeConfig } from '@portal/form/data-access';
import { Helper } from '@portal/util';
import { PreviewFileDirective } from '@portal/preview-file/data-access';

@Component({
  selector: 'portal-application-review-board-resolution',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, MatIconModule, NgIf, NgForOf, PreviewFileDirective],
  template: `
    <div class="field-label">
      I have reviewed the
      <button
        (click)="reviewBoardResolution()"
        class="text-primary underline"
      >
        Board Resolution
      </button>
      <span class="text-primary">*</span>
    </div>
  `,
  providers: [PreviewFileDirective],
})
export class ReviewBoardResolutionComponent extends FieldType<PortalFieldTypeConfig> {
  private readonly previewFile = inject(PreviewFileDirective);

  reviewBoardResolution(): void {
    // console.log(this.model);

    if (!this.model.attachment.size) return;

    const [first] = this.model.attachment.values();

    if (first) {
      const { file, key } = first;
      if (file) {
        Helper.openInNewTab(file, '_blank');
      } else if (key) {
        this.previewFile.keyName = key;
        this.previewFile.previewFile();
      }
    }
  }
}

@NgModule({
  imports: [
    FormlyModule.forChild({
      types: [
        {
          name: 'form-review-board-resolution',
          wrappers: ['form-field'],
          component: ReviewBoardResolutionComponent,
        },
      ],
    }),
  ],
})
export class ReviewBoardResolutionModule {}
